import { Box, BoxProps, Center, Text, chakra } from '@chakra-ui/react';
import * as React from 'react';

import { BACKGROUND_COLOR } from '@/modules/website-builder/attributes';
import { validateEmbedUrl } from '@/modules/website-builder/embed-url';
import { Embed } from '@/modules/website-builder/types';

export const EmbedRender: React.FC<{ embed: Embed } & BoxProps> = ({
  embed,
  ...props
}) => {
  const validation = validateEmbedUrl(embed.url ?? '');
  const height = embed.options.height > 0 ? embed.options.height : 400;

  return (
    <Box
      w="full"
      backgroundColor={BACKGROUND_COLOR[embed.options.backgroundColor]}
      {...props}
    >
      <Box w="full" maxW="container.lg" mx="auto" px="4">
        {validation.ok ? (
          <chakra.iframe
            title={embed.name || 'Embedded content'}
            src={validation.url}
            width="100%"
            height={`${height}px`}
            border="0"
            borderRadius="md"
            loading="lazy"
            // YouTube / Vimeo reject no-referrer embeds; keep a safe default.
            referrerPolicy="strict-origin-when-cross-origin"
            // Restrict iframe capabilities; allow scripts so countdown widgets work.
            sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-presentation"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        ) : (
          <Center
            h={`${height}px`}
            borderWidth="1px"
            borderStyle="dashed"
            borderColor="gray.300"
            borderRadius="md"
            px="4"
            textAlign="center"
          >
            <Text color="gray.500" textStyle="detail">
              {embed.url
                ? validation.reason
                : 'Add an embed URL in the sidebar to show content here.'}
            </Text>
          </Center>
        )}
      </Box>
    </Box>
  );
};
